import React from 'react'

interface RoundedChatIconProps {
  className?: string
  style?: React.CSSProperties
}

// Smooth rounded speech bubble (message-circle glyph).
// One of the alternative icon styles available on Growth+ plans.
export const RoundedChatIcon: React.FC<RoundedChatIconProps> = ({ className, style }) => {
  return (
    <span
      className={className}
      style={{ ...style, display: 'inline-block', lineHeight: 0 }}
    >
      <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
      </svg>
    </span>
  )
}
